export function header() {
  const openButton = document.querySelector('[data-js="hamburger-open"]');
  const closeButton = document.querySelector('[data-js="hamburger-close"]');
  const overlay = document.querySelector('[data-js="hamburger-overlay"]');
  const menu = document.querySelector('[data-js="header-menu"]');

  function setStatus(element, status) {
    element.setAttribute("data-status", status);
  }

  function activateMenu() {
    setStatus(menu, "active");
    setStatus(overlay, "active");
  }

  function deactivateMenu() {
    setStatus(menu, "inactive");
    setStatus(overlay, "inactive");
  }

  openButton.addEventListener("click", activateMenu);
  closeButton.addEventListener("click", deactivateMenu);
  overlay.addEventListener("click", deactivateMenu);
}
